import copy from 'copy-to-clipboard';

import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

type Options = {
	/**
	 * When the copy fails, show a `window.prompt` holding the text for a manual copy. Defaults to true.
	 * Pass false when a later step of the same tap needs the user activation, such as a `window.open`:
	 * a blocking prompt can use it up on iOS Safari.
	 */
	fallbackToPrompt?: boolean;
};

export async function copyToClipboard(
	text: string,
	{ translate }: UtilityContext['i18n'],
	{ fallbackToPrompt = true }: Options = {},
): Promise<boolean> {
	// TODO different message for desktop?
	const message = translate('fe.components.share_buttons.mobile_copy_text');
	return copy(text, { format: 'text/plain', message, fallbackToPrompt });
}
